const types = {
	status: 'status',
	approve: 'approve',
	rejected: 'rejected',
	trash: 'trash',
	pending: 'pending'
};

const locale = {
	ru: {
		status: 'при смене статуса',
		approve: 'только подтверженные',
		rejected: 'отмененные',
		trash: 'невалидные',
		pending: 'при создании'
	},
	en: types,
	uk: types,
	de: {
		status: 'Status',
		approve: 'nur bestätigte',
		rejected: 'abgelehnt',
		trash: 'müll',
		pending: 'beim Erstellen'
	},
	vi: types,
	th: {
		status: 'ในกรณีเปลี่ยนสถานะ',
		approve: 'ยืนยันแล้วเท่านั้น',
		rejected: 'ถูกปฏิเสธ',
		trash: 'ใช้ไม่ได้',
		pending: 'เมื่อสร้าง'
	}
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/postback-types.js